// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"e60c1693","864":"e351d6fa"}[chunkId] + ".chunk.js";
};